/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockDatas.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Block Datas
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 28, 2018 - 06:48:21 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      10/28/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCKDATA_LIST_CONTAINER_LOADED,
    BLOCKDATA_LIST_CONTAINER_UNLOADED,
    BLOCKDATA_LIST_TABLE_LOADED,
    BLOCKDATA_LIST_TABLE_UNLOADED,

    BLOCKDATA_LIST_CHANGE_GROUP,
    BLOCKDATA_SELECT_ROW,
    BLOCKDATA_ADD,
    BLOCKDATA_EDIT,
    BLOCKDATA_DELETE,
    BLOCKDATA_OPEN_WARNING,
    BLOCKDATA_CLOSE_WARNING,

    BLOCKDATA_EDIT_CONTAINER_LOADED,
    BLOCKDATA_EDIT_CONTAINER_UNLOADED,
    BLOCKDATA_EDIT_COMPANIES_LOADED,
    BLOCKDATA_EDIT_USERS_LOADED,
    BLOCKDATA_EDIT_BLOCKGROUP_LOADED,
    BLOCKDATA_EDIT_BLOCKTREE_LOADED,

    BLOCKDATA_UPDATE_VALUE,

    BLOCKDATA_EDIT_DRAW_COMPANYOPTIONS,
    BLOCKDATA_EDIT_DRAW_USEROPTIONS,
    BLOCKDATA_EDIT_DRAW_BLOCKTREE,
    BLOCKDATA_EDIT_BLOCKFORMAT_LOADED,
    BLOCKDATA_EDIT_FORM_LOADED,
    BLOCKDATA_EDIT_FORM_UNLOADED,
    BLOCKDATA_EDIT_DATA_LOAD,
    BLOCKDATA_EDIT_CONTAINER_SUBMIT,
    BLOCKDATA_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockDatas';

const defaultState = {
    refreshList: false,
    danger: false,
    blockdataid: 0,
    companyid: 0,
    userid: 0,
    primarykeyid: 0,
    name: '',
    description: '',
    joinkey: '',
    createdate: '',
    modifydate: '',
    tagname: '',
    cmsselect: false
};

let result = null;

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKDATA_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockdatas: action.payload[0] ? action.payload[0].records : null,
                blockgroups: action.payload[1] ? action.payload[1].records : null
            }
        case BLOCKDATA_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockdatas: action.payload[0] ? action.payload[0].records : null
            }
        case BLOCKDATA_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case BLOCKDATA_SELECT_ROW:
            return {
                ...state,
                blockdataid: action.id
            }
        case BLOCKDATA_ADD:
            return {
                ...state
            }
        case BLOCKDATA_EDIT:
            return {
                ...state,
                blockdataid: action.id
            }
        case BLOCKDATA_DELETE:
            return {
                ...state,
                blockdataid: null
            }
        case BLOCKDATA_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCKDATA_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCKDATA_EDIT_CONTAINER_LOADED:
        case BLOCKDATA_EDIT_DATA_LOAD:
            result = {
                ...state,
                blockdataid: action.payload[0] ? action.payload[0].blockdataid : 0,
                blockgroupid: action.payload[0] ? action.payload[0].blockgroupid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                userid: action.payload[0] ? action.payload[0].userid : 0,
                primarykeyid: action.payload[0] ? action.payload[0].primarykeyid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                joinkey: action.payload[0] ? action.payload[0].joinkey : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
            if (action.payload[0] && action.payload[0].customFields) {
                result['customFields'] = action.payload[0].customFields
            }
            return result;
        case BLOCKDATA_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case BLOCKDATA_EDIT_COMPANIES_LOADED:
            return {
                ...state,
                companies: action.payload ? action.payload.companies : []
            }
        case BLOCKDATA_EDIT_USERS_LOADED:
            return {
                ...state,
                users: action.payload ? action.payload.users : []
            }
        case BLOCKDATA_EDIT_BLOCKGROUP_LOADED:
            return {
                ...state,
                blockgroup: action.payload ? action.payload.name : ''
            }
        case BLOCKDATA_EDIT_BLOCKTREE_LOADED:
            return {
                ...state,
                blocktree: action.payload ? action.payload.records : []
            }
        case BLOCKDATA_EDIT_DRAW_COMPANYOPTIONS:
            return {
                ...state,
                companyOptions: action.payload ? action.payload : null
            }
        case BLOCKDATA_EDIT_DRAW_USEROPTIONS:
            return {
                ...state,
                userOptions: action.payload ? action.payload : null
            }
        case BLOCKDATA_EDIT_DRAW_BLOCKTREE:
            return {
                ...state,
                blockTreeDisplay: action.payload ? action.payload : null
            }
        case BLOCKDATA_EDIT_BLOCKFORMAT_LOADED:
            return {
                ...state,
                blockformat: action.payload ? action.payload.records : []
            }
        case BLOCKDATA_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCKDATA_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCKDATA_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCKDATA_LIST_CONTAINER_UNLOADED:
        case BLOCKDATA_LIST_TABLE_UNLOADED:
        case BLOCKDATA_EDIT_CONTAINER_UNLOADED:
        case BLOCKDATA_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockDatas.js